export let Role = {
  admin: 'admin'
  
}

export let DrawerItems = [
  {
    name: 'Кабинет',
    path: '/admin/cabinet',
    icon: 'twotone-event_note-24px.png', 
    requiredRoles: [Role.admin]
  },
  {
    name: 'Страницы',
    path: '/admin/pages',
    icon: 'twotone-event_note-24px.png', 
    requiredRoles: [Role.admin]
  },
  {
    name: 'Тесты',
    path: '/admin/tests',
    icon: 'twotone-event_note-24px.png', 
    requiredRoles: [Role.admin]
  },
  {
    name: 'Результаты диктанта',
    path: '/admin/dictresults',
    icon: 'twotone-event_note-24px.png', 
    requiredRoles: [Role.admin]
  },
  {
    name: 'Глобальные настройки',
    path: '/admin/settings',
    icon: 'twotone-event_note-24px.png', 
    requiredRoles: [Role.admin]
  }
]